import { render, staticRenderFns } from "./MultiSelectBox.vue?vue&type=template&id=81d037a6&scoped=true"
import script from "./MultiSelectBox.vue?vue&type=script&lang=js"
export * from "./MultiSelectBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d037a6",
  null
  
)

export default component.exports